export interface PassengerIdEntry {
  id: string;
  segmentCode: string;
}

/**
 * Resolves the correct passengerId from a PassengerIds array for a given segment.
 * Resolution rule: segment match → first element → null.
 */
export function resolvePassengerIdForSegment(
  passengerIds: PassengerIdEntry[] | null | undefined,
  currentSegmentCode: string
): string | null {
  if (!Array.isArray(passengerIds) || passengerIds.length === 0) {
    return null;
  }
  const segmentMatch = passengerIds.find((entry) => entry.segmentCode === currentSegmentCode);
  if (segmentMatch) {
    return segmentMatch.id;
  }
  return passengerIds[0]?.id ?? null;
}
